import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TestResultFilters} from '../../../../data/models/filters/test-result-filters';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-test-result-filters',
  templateUrl: './test-result-filters.component.html',
  styleUrls: ['./test-result-filters.component.css']
})
export class TestResultFiltersComponent implements OnInit, OnChanges {

  @Input() filters: TestResultFilters = {};

  @Output() apply = new EventEmitter<TestResultFilters>();

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      search: [''],
      isFinished: [null],
      isChecked: [null],
    });
  }

  ngOnInit(): void {
    this.form.controls.search.setValue(this.filters.search);
    this.form.controls.isFinished.setValue(this.filters.isFinished);
    this.form.controls.isChecked.setValue(this.filters.isChecked);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filters = changes.filters.currentValue;
    this.form.controls.search.setValue(filters.search);
    this.form.controls.isFinished.setValue(filters.isFinished);
    this.form.controls.isChecked.setValue(filters.isChecked);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    const search = this.form.controls.search.value || null;
    const isFinished = this.form.controls.isFinished.value;
    const isChecked = this.form.controls.isChecked.value;
    this.apply.emit({search, isFinished, isChecked});
  }

  onClear(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.search.setValue('');
    this.form.controls.isFinished.setValue(null);
    this.form.controls.isChecked.setValue(null);
    this.apply.emit({});
  }

}
